import { Observable } from 'rxjs';

export interface PDialogFooterBtnConfig {
    text?: string;
    type?: PDialogFooterBtnActionType;
    click?: () => any;
    disabled?: boolean;
    disabled$?: Observable<boolean>;
    tooltip?: string;
    tooltipPosition?: 'above' | 'below' | 'left' | 'right';
    automationId?: string;
    className?: string;
    isCamelCase?: boolean;
}

export enum PDialogFooterBtnActionType {
    Close,
    Destructive,
    Regular
}
export enum DeactivateResult {
    LEAVE,
    SAVE,
    DISCARD
}
